export default __webpack_public_path__ + "static/media/logo.45dcd7a9.png";